export default __webpack_public_path__ + "static/media/alert-red.637b083a.svg";